import { Role } from '@customTypes/types';
import { AppShell, Flex, ScrollArea, Space, Title } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { useEffect, useMemo } from 'react';

import {
  useGetChatProfileQuery,
  useGetConversationsListQuery
} from '@/features/chat/api';
import { AdminConversationitem } from '@/features/chat/components/AdminConversationItem/AdminConversationItem';
import { ConversationsList } from '@/features/chat/modules';
import { useChatStore } from '@/features/chat/store/chatStore';

export const AdminChat = () => {
  const { updateChatProfile } = useChatStore();
  const profile = useGetChatProfileQuery({
    profileId: '',
    profileType: Role.admin
  });

  useEffect(() => {
    if (profile.data?.data.chatProfileId) {
      updateChatProfile(profile.data?.data);
    }
  }, [profile.data?.data.avatarUrl]);

  const conversationList = useGetConversationsListQuery(
    {
      chatProfileId: profile.data?.data.chatProfileId!
    },
    {
      options: {
        refetchInterval: 5000,
        refetchIntervalInBackground: true,
        retry: 3,
        enabled: !!profile.data?.data.chatProfileId
      }
    }
  );

  const sortedConversations = useMemo(
    () =>
      conversationList.data?.data.sort((a, b) => {
        if (a.isAssistanceRequested !== b.isAssistanceRequested) {
          return a.isAssistanceRequested ? -1 : 1;
        }
        return b.newMessageCount - a.newMessageCount;
      }),
    [conversationList.data?.data]
  );

  return (
    <>
      <AppShell.Main w='45%'>
        <ScrollArea offsetScrollbars h='100%' type='hover'>
          {conversationList.data?.data && (
            <ConversationsList
              conversations={sortedConversations!}
              renderItem={AdminConversationitem}
            />
          )}
        </ScrollArea>
      </AppShell.Main>

      <AppShell.Aside p={20} w='55%'>
        <Flex direction='column' h='95vh'>
          <Title order={3}>Активныи чат</Title>
          <Space h={20} />
          <Flex bd='1px solid #e8e8e8' miw='400px' pos='relative'>
            <Outlet />
          </Flex>
        </Flex>
      </AppShell.Aside>
    </>
  );
};
